



export default (endpoint:string, options?:object) => {
    let defaultOptions = {
        headers: {
            'Accept': 'application/json',
            'Access-Control-Allow-Origin':'*',
            'projectid': import.meta.env.VITE_CMS_PROJECT_ID ? import.meta.env.VITE_CMS_PROJECT_ID : ""
        }
    };
    
    if (typeof options === "object") {
        defaultOptions = {...defaultOptions, ...options};
    }
    
    const is_local = import.meta.env.MODE === 'development'
    return fetch(is_local ? "https://client.dev.w.ecredit.md/api/cms/api/module/app_docs/list" : import.meta.env.VITE_CMS_API + endpoint, defaultOptions);
}
